import { Command } from '@workbuddy/ui/model';
import { ActivityEntityName, EntityQueue, EntityQueueType } from '@jms/model';
import { SettingsPanelBuilder } from '@workbuddy/ui/v2/blocks/settings.panel';
import { nameRequired } from '../validators/name.required.validator';
import { injectQueueNameUniqueChecker, nameUnique } from '../validators/name.unique.validator';
import { QueueAdapterContext, QueueStepAdapter } from './queue.step.adapter';

export function createSetupAdapter(): QueueStepAdapter {

  return {
    build: (ctx: QueueAdapterContext, model: Partial<EntityQueue>, wizard) => {

      const isQueueNameUnique = injectQueueNameUniqueChecker();

      const entityOptions = [
        { id: ActivityEntityName.Job, label: 'Job' },
        { id: ActivityEntityName.WorkOrder, label: 'Stage' },
      ];

      // Model values model the inputs when re-entering after a back nav
      // (none today, but harmless) or for completeness on reset.
      const initialEntity = model.entity ?? model.targetEntity ?? ActivityEntityName.Job;

      return new SettingsPanelBuilder('Create Queue')
        .input('name', 'Name', {
          placeholder: 'Queue name',
          value: model.name ?? '',
          autofocus: 'selectAll',
          errorMessage: { required: 'Queue name is required', unique: 'Queue name already taken' },
        })
        .tabs('type', 'Queue Type', {
          commands: [
            new Command({ _id: EntityQueueType.Flag, label: 'Flag' }),
            new Command({ _id: EntityQueueType.Entity, label: 'Entity' }),
          ],
          selected: model.type ?? EntityQueueType.Flag,
        })
        .dropdown('entity', 'Entity', {
          options: entityOptions,
          selected: initialEntity,
        })
        .validator(nameRequired)
        .validatorAsync(nameUnique(name => isQueueNameUnique(name, model._id)))
        .footerRight(new Command({ label: 'Cancel', action: () => ctx.onCancel() }))
        .footerSplitButton(new Command({ label: 'Continue', action: () => wizard.next() }), [])
        .build();
    },
  };
}
